module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-900.woff?fde0f399fa4b71074e88b511f893c492";